import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as RaceActions from "../../../../actions/race";
import {NotificationManager} from "react-notifications";
import {confirm} from "../../../../utils/confirmDialog";

import PriceAdditionsDialog from '../dialogs/PriceAdditionsDialog';
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class RacePrices extends React.Component {

    static propTypes = {
        race: PropTypes.object,
        setEditMode: PropTypes.func.isRequired,
        setAllowNew: PropTypes.func.isRequired,
        showPriceAdditionsDialog: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            priceType: null,
            editIx: null,
        };
    }

    componentDidMount() {
        this.props.dispatch(RaceActions.getPrices(this.props.race.Nr));
    }

    fields = [];
    render() {
        return <div className={"form-page race-prices " + (this.state.editIx !== null ? "editable" : "read-only")}>
            <div className="top-left-panel">
                <div className="outer-content">
                    <div className="inner-content">
                        <UserFieldElement dataType={UserFieldDataType.options} className="" containerClassName="display-inline-block" disabled={this.state.editIx !== null}
                                          name="priceType" id="priceType" value={this.state.priceType} options={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? [
                                              {key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null || this.props.race.Kontantpraemier === null || this.props.race.Kontantpraemier === 0},
                                              {key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null || this.props.race.Slagpraemier === null || this.props.race.Slagpraemier === 0},
                                          ] : [
                                              {key: 'kontant', value: 'Kontantpræmier', disabled: this.state.editIx !== null || this.props.race.Kontantpraemier === null || this.props.race.Kontantpraemier === 0},
                                              {key: 'slagspil', value: 'Slagspilspræmier', disabled: this.state.editIx !== null || this.props.race.SlagspilS === null || this.props.race.SlagspilS === 0},
                                              {key: 'espil', value: 'E-splispræmier', disabled: this.state.editIx !== null || this.props.race.KlE === null || this.props.race.KlE === 0},
                                              {key: 'pspil', value: 'P-spilspræmier', disabled: this.state.editIx !== null || this.props.race.KlP === null || this.props.race.KlP === 0},
                                              {key: 'zspil', value: 'Z-spilspræmier', disabled: this.state.editIx !== null || this.props.race.KlZ === null || this.props.race.KlZ === 0},
                                              {key: 'dm', value: 'DM-præmier', disabled: this.state.editIx !== null || this.props.race.KlR === null || this.props.race.KlR === 0},
                                              {key: 'slag', value: 'Slagpræmier', disabled: this.state.editIx !== null || this.props.race.Slagpraemier === null || this.props.race.Slagpraemier === 0},
                                              //this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : {key: 'serie', value: 'Seriepræmier', disabled: this.state.editIx !== null || this.props.race.SeriepraemierAntalDuer === null},
                                              //this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : {key: 'derby', value: 'Derbypræmier', disabled: this.state.editIx !== null || this.props.race.Derbyaar === null},
                                          ]}
                                          autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={e => {
                                              this.setState({priceType: e.target.value});
                                              this.props.setAllowNew(true);
                                          }}
                                          ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                </div>
            </div>
            <div className="top-right-panel">
                <div id="data-table" className="outer-content">
                    <div className="inner-content">
                        <table className="data-table">
                            <thead>
                                <tr>
                                    <th>Antal</th>
                                    <th>Værdi</th>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektion</th> : null}
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.priceType !== null && this.props.racePrices.get(this.props.race.Nr) ? this.props.racePrices.get(this.props.race.Nr)[this.state.priceType].sort((p1, p2) => {
                                    if (p1.Sektion < p2.Sektion) return -1;
                                    if (p1.Sektion > p2.Sektion) return 1;
                                    if (p1.Vaerdi > p2.Vaerdi) return -1;
                                    if (p1.Vaerdi < p2.Vaerdi) return 1;
                                    return 0;
                                }).concat(this.state.editIx === 'new/new' ? [['new/new', {Sektion: 'new', Vaerdi: 'new'}]] : []).toArray().map(price => <tr key={price.Sektion + '/' + price.Vaerdi} id={'row-' + price.Sektion + '-' + price.Vaerdi}>
                                    <td>{
                                        this.state.editIx === price.Sektion + '/' + price.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field75" containerClassName="display-inline-block"
                                                       name="Antal" id="Antal" value={this.state.Antal}
                                                       autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                       onChange={this.onStandardFieldChange}
                                                       ref={instance => { this.fields[1] = instance; }}
                                        /> : price.Antal
                                    }</td>
                                    <td>{
                                        this.state.editIx === price.Sektion + '/' + price.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.float} placeholder="" className="field100" containerClassName="display-inline-block"
                                                       name="Vaerdi" id="Vaerdi" value={this.state.Vaerdi}
                                                       autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                       onChange={this.onStandardFieldChange}
                                                       ref={instance => { this.fields[2] = instance; }}
                                        /> : String(price.Vaerdi).replace('.', ',')
                                    }</td>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{
                                        this.state.editIx === price.Sektion + '/' + price.Vaerdi ? <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field100" containerClassName="display-inline-block"
                                                       name="Sektion" id="Sektion" maxLength="6" value={this.state.Sektion}
                                                       autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                       onChange={this.onStandardFieldChange}
                                                       ref={instance => { this.fields[3] = instance; }}
                                        /> : price.Sektion
                                    }</td> : null}
                                    <td>{
                                        this.state.editIx === price.Sektion + '/' + price.Vaerdi ? [
                                            <i key={0} className="fa fa-save clickable" title="Gem præmie" onClick={this.save}/>,
                                            <i key={1} className="fa fa-undo clickable" title="Annuller" onClick={this.cancelEdit}/>
                                        ] : [
                                            <i key={0} className={"fa fa-pencil " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Rediger række" onClick={() => {
                                                if (this.state.editIx === null) this.setState({
                                                    Sektion: price.Sektion,
                                                    Vaerdi: String(price.Vaerdi).replace('.', ','),
                                                    Antal: price.Antal === null ? '' : String(price.Antal),
                                                    oldSektion: String(price.Sektion),
                                                    oldVaerdi: String(price.Vaerdi),
                                                    editIx: price.Sektion + '/' + price.Vaerdi,
                                                });
                                                this.props.setEditMode(true);
                                            }}/>,
                                            <i key={1}
                                               className={"fa fa-trash " + (this.state.editIx === null ? 'clickable' : 'disabled')} title="Slet præmie" onClick={() => {
                                                if (this.state.editIx === null) confirm("Slet", <span>Ønsker du at slette præmien på <b>{price.Vaerdi} DKK</b>{price.Sektion === '' ? '' : <span> for sektion <b>{price.Sektion}</b></span>}?</span>, () => {
                                                    this.props.dispatch(RaceActions.deletePrice(this.state.priceType, this.props.race.Nr, price.Sektion, price.Vaerdi, () => {
                                                        NotificationManager.success("Præmien på " + price.Vaerdi + ' DKK' + (price.Sektion === '' ? '' : ' for sektion ' + price.Sektion) + " er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            }}/>
                                        ]
                                    }</td>
                                </tr>) : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-left-panel">
                <div className="outer-content">
                    {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className="inner-content">
                        Præmiepulje kan ikke overstige samlede indskud
                    </div>}
                </div>
            </div>
            <div className="bottom-right-panel">
                <div className="outer-content">
                    <div className="inner-content">
                        {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <span className="pool-prices">
                            <span className="pool-prices-option">
                                <label htmlFor="PuljePuljepraemier" className={this.props.race.KlP === null || this.props.race.KlP === 0 ? 'disabled' : ''}>Pulje</label>
                                <input id="PuljePuljepraemier" name="PuljePuljepraemier" type="checkbox" checked={this.props.race.PuljePuljepraemier !== null && this.props.race.PuljePuljepraemier !== 0}
                                       disabled={this.props.race.KlP === null || this.props.race.KlP === 0} onChange = {this.onPoolPriceClick}/>
                            </span>
                            <span className="pool-prices-option">
                                <label htmlFor="ElitePuljepraemier" className={this.props.race.KlE === null || this.props.race.KlE === 0 ? 'disabled' : ''}>Elite</label>
                                <input id="ElitePuljepraemier" name="ElitePuljepraemier" type="checkbox" checked={this.props.race.ElitePuljepraemier !== null && this.props.race.ElitePuljepraemier !== 0}
                                       disabled={this.props.race.KlE === null || this.props.race.KlE === 0} onChange = {this.onPoolPriceClick}/>
                            </span>
                            <span className="pool-prices-option">
                                <label htmlFor="Z_Puljepraemier" className={this.props.race.KlZ === null || this.props.race.KlZ === 0 ? 'disabled' : ''}>Z-spil</label>
                                <input id="Z_Puljepraemier" name="Z_Puljepraemier" type="checkbox" checked={this.props.race.Z_Puljepraemier !== null && this.props.race.Z_Puljepraemier !== 0}
                                       disabled={this.props.race.KlZ === null || this.props.race.KlZ === 0} onChange = {this.onPoolPriceClick}/>
                            </span>
                            <span className="pool-prices-option">
                                <label htmlFor="R_Puljepraemier" className={this.props.race.KlR === null || this.props.race.KlR === 0 ? 'disabled' : ''}>DM</label>
                                <input id="R_Puljepraemier" name="R_Puljepraemier" type="checkbox" checked={this.props.race.R_Puljepraemier !== null && this.props.race.R_Puljepraemier !== 0}
                                       disabled={this.props.race.KlR === null || this.props.race.KlR === 0} onChange = {this.onPoolPriceClick}/>
                            </span>
                        </span>}
                        <span className="actions">
                            <button className="btn-primary" title="Opret standardpræmier som konfigureret under indstillinger" disabled={this.state.editIx !== null || this.state.priceType === null} onClick = {() => {
                                this.props.dispatch(RaceActions.resetPrices(this.state.priceType, this.props.race.Nr, () => {
                                    NotificationManager.success("Præmierne er nulstillet.", "Nulstilling", 4000);
                                }));
                            }}>Standard</button>
                            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : [<button className="btn-primary" title="Beregn præmier" disabled={this.state.editIx !== null || (this.state.priceType !== 'pspil' && this.state.priceType !== 'zspil' && this.state.priceType !== 'serie' && (this.state.priceType !== 'kontant' || this.props.race.LMU !== 'O'))} onClick = {() => {
                                this.props.dispatch(RaceActions.calcPrices(this.state.priceType, this.props.race.Nr, () => {
                                    NotificationManager.success("Præmierne er beregnet.", "Beregning", 4000);
                                }));
                            }}>Beregn</button>,
                            <button className="btn-primary" title="Beregn præmietillæg  " disabled={this.state.editIx !== null || (this.state.priceType !== 'kontant' || this.props.race.LMU !== 'O')} onClick = {() => {
                                this.setState({showPriceAdditionsDialog: true});
                            }}>Præmietillæg</button>]}
                        </span>
                    </div>
                </div>
            </div>
            {this.state.showPriceAdditionsDialog ? <PriceAdditionsDialog onClose={() => {this.setState({showPriceAdditionsDialog: false})}} onSuccess={() => {}}
                raceId={this.props.race.Nr} priceType={this.state.priceType} sections={this.props.admin.sections.filter(section => section.Sektionsnr < '7').map(section => {
                    const addition = this.state.priceType !== null && this.props.racePrices.get(this.props.race.Nr) && this.props.racePrices.get(this.props.race.Nr)[this.state.priceType + 'Additions'] ?
                        this.props.racePrices.get(this.props.race.Nr)[this.state.priceType + 'Additions'].get(section.Sektionsnr) : null;
                    return {
                        Sektionsnr: section.Sektionsnr,
                        Beloeb: addition ? addition.Beloeb : null,
                    }
                }).toArray()}
            /> : null}
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onPoolPriceClick = (e) => {
        const stateVariable = e.target.name;
        this.props.dispatch(RaceActions.updateRace(this.props.race.Nr, {
            [e.target.name]: e.target.checked ? -1 : 0 // Toggle value
        }, () => {
            NotificationManager.success("Indstillingen for puljepræmier er gemt.", "Opdatering", 4000);
        }));
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field, ix) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    createNew = () => {
        this.setState({
            Antal: '1',
            Vaerdi: '',
            Sektion: '',
            editIx: 'new/new'
        });
        this.props.setEditMode(true);
        setTimeout(function () {
            const content = document.getElementById("data-table");
            content.scrollTop = content.scrollHeight;
        });
    };

    cancelEdit = () => {
        this.setState({editIx: null});
        this.props.setEditMode(false);
    };

    save = () => {
        if (this.allInputValid()) {
            const entity = {
                Antal: this.state.Antal === '' ? null : Number(this.state.Antal),
                Vaerdi: this.state.Vaerdi === '' ? null : Number(this.state.Vaerdi.replace(',', '.')),
                Sektion: this.state.Sektion,
            };
            if (this.state.editIx === 'new/new') {
                entity.Kapflyvningsnr = this.props.race.Nr;
                this.props.dispatch(RaceActions.createPrice(this.state.priceType, entity, () => {
                    NotificationManager.success("Præmien på " + this.state.Vaerdi + " DKK" + (this.state.Sektion === '' ? '' : ' for sektion ' + this.state.Sektion) + " er oprettet.", "Oprettelse", 4000);
                    this.setState({editIx: null});
                    this.props.setEditMode(false);
                    setTimeout(function () {
                        const currentRow = document.getElementById("row-" + this.state.Sektion + "-" + this.state.Vaerdi);
                        currentRow.scrollIntoView(false);
                    }.bind(this));
                }));
            } else this.props.dispatch(RaceActions.updatePrice(this.state.priceType, this.props.race.Nr, this.state.oldSektion, this.state.oldVaerdi, entity, () => {
                NotificationManager.success("Præmien på " + this.state.Vaerdi + " DKK" + (this.state.Sektion === '' ? '' : ' for sektion ' + this.state.Sektion) + " er opdateret.", "Opdatering", 4000);
                this.setState({editIx: null});
                this.props.setEditMode(false);
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + this.state.Sektion + "-" + this.state.Vaerdi);
                    currentRow.scrollIntoView(false);
                }.bind(this));
            }));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        clubs: state.admin.clubs,
        sections: state.admin.sections,
    },
    racePrices: state.race.racePrices,
});

export default connect(mapStateToProps, null, null, {withRef: true})(RacePrices);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/race/subPages/RacePrices.js